import { useState } from "react"
import { observer } from "mobx-react"
import { Button, Form, Input } from "antd"
import { useForm } from "antd/es/form/Form"

import { FormContainer } from "@src/app/components/FormContainer"
import { Navigation } from "@src/app/components/navigation"
import { useCatchFormErrors } from "@src/shared/form/base_error"
import { ChangePasswordStore } from "./store"

const { Item } = Form

export const PasswordChangePage = observer(() => {
  const [store] = useState(new ChangePasswordStore())

  const { changePassword, isLoading } = store

  const [form] = useForm()

  const { submit } = useCatchFormErrors(form, changePassword)

  const title = "Change Password"

  return (
    <div>
      <Navigation title={title} />
      <FormContainer
        form={form}
        name="changePassword"
        onFinish={submit}
        style={{ marginTop: "32px" }}
      >
        <Item
          hasFeedback
          label="Current Password"
          name="current_password"
          rules={[
            {
              message: "Please input your password",
              required: true,
            },
            {
              message: "The length must be no less than 8 characters",
              min: 8,
            },
          ]}
        >
          <Input.Password disabled={isLoading} />
        </Item>
        <Item
          hasFeedback
          label="New Password"
          name="new_password"
          rules={[
            {
              message: "Please input your password",
              required: true,
            },
            {
              message: "The length must be no less than 8 characters",
              min: 8,
            },
          ]}
        >
          <Input.Password disabled={isLoading} />
        </Item>
        <Item
          dependencies={["new_password"]}
          hasFeedback
          label="Confirm Password"
          name="confirm_password"
          rules={[
            {
              message: "Please confirm your password",
              required: true,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve()
                }

                return Promise.reject(new Error("Does not match password"))
              },
            }),
          ]}
        >
          <Input.Password disabled={isLoading} />
        </Item>

        <Item>
          <Button
            htmlType="submit"
            id="GENERATED_ID_PASSWORDCHANGE_BUTTON_VOID_1"
            loading={isLoading}
            type="primary"
          >
            {title}
          </Button>
        </Item>
      </FormContainer>
    </div>
  )
})
